module.exports = __webpack_public_path__ + "static/img/0008-test.666a43d2.png";